import {forwardRef, useEffect, Ref} from 'react';
import {DetailedProps, join, useId} from '../utils';
import {Selectors} from './modal.selectors';
import {useModalContext} from './use-modal-context';

import styles from './modal.module.less';

export type HeaderProps = DetailedProps<HTMLHeadElement>;

function ModalHeader(props: HeaderProps, ref: Ref<HTMLHeadElement>): JSX.Element {
	const context = useModalContext();
	const id = useId();

	useEffect(() => context.setLabelMeta(id));
	return <header data-cy={Selectors.Header}
	               {...props}
	               ref={ref}
	               id={id}
	               className={join(styles.header, props.className)}/>;
}

export const Header = forwardRef(ModalHeader);
